import { Box, Heading, Stack } from "@sembark-travel/ui-base"
import { ActivityLogs } from "../../../../ActivityLogs"
import { Helmet } from "react-helmet-async"
import { useParams } from "../../../../router"

export default function VisaServiceActivities() {
	const { visaServiceId } = useParams("/visa/:visaServiceId")
	return (
		<>
			<Helmet>
				<title>Visa Service Activities</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				<Stack gap="2">
					<Heading as="h5">Activities</Heading>
					<ActivityLogs
						subjectType="visa_services"
						subjectId={Number(visaServiceId)}
						hideTrackingInfo
					/>
				</Stack>
			</Box>
		</>
	)
}
